'use strict'

var Marionette = require('backbone.marionette')

// Create the application instance
var app = Marionette.Application.extend({
  initialize: function () {
    this._modules = []
  },
  initializeModule: function (name, callback) {
    var module = this._modules[name]
    if (!module.initialize) return module

    return module.initialize(callback)
  },
  getModule: function (name) {
    return this._modules[name]
  },
  addModule: function (name, Something, options) {
    var module = new Something(options)
    this._modules[name] = module
    return this._modules[name]
  }
})

var App = new app()

App.entities = {}
App.collections = {}
App.models = {}

module.exports = App



// WEBPACK FOOTER //
// ./js/app.js